// utils
import { endpoints } from 'src/utils/axios';
import useGetData from 'src/hooks/use-get-data';

// Types
export interface CreditMovement {
  productId: string;
  litres: number;
  productName: string;
  orderId: string | null;
  orderDate: string | null;
  eadDocumentNumber: string;
  eadClosingDate: string | null;
  producerDocNumber: string;
}

export interface DebitMovement {
  productId: string;
  litres: number;
  productName: string;
  orderId: string | null;
  orderDate: string | null;
  eadDocumentNumber: string | null;
  eadClosingDate: string | null;
}

export interface ExciseRegisterData {
  registerDate: string;
  openingBalanceLitres: number;
  creditLitres: number;
  debitLitres: number;
  closingBalanceLitres: number;
  movementCount: number;
  creditMovements: CreditMovement[];
  debitMovements: DebitMovement[];
}

// Hook: Fetch excise register data
export function useGetExciseRegister(date: string) {
  return useGetData<undefined, ExciseRegisterData>({
    endpoint: endpoints.public.exciseRegister(date),
  });
}
